import { apiService } from './axios.client';

export const RoleEndPoints = {
    getRoleByUserId: function (input, callback) {
        apiService.get('/role/GetRolesByUserId', input)
            .then((response) => callback(response, input.props))
            .catch(error => {
                alert(error);
                if (callback) {
                    callback(error.response || error, input?.props);
                }
            });
    },
    getProductsByCompanyId: function (input, callback) {
        apiService.get('/role/GetProductsByCompanyId', input)
            .then((response) => callback(response, input.props))
            .catch(error => alert(error));
    },
    getRoleList: function (input, callback) {
        apiService.get('/role/GetRoleList', input)
            .then((response) => callback(response))
            .catch(error => alert(error));
    },
};

